import React from "react";
import { Helmet } from "react-helmet";
import { HiOutlineDocumentDownload } from "react-icons/hi";

function MandatoryDisclosures() {
  const disclosureDocuments = [
    { title: "Barrier Free Campus", link: "/docs/Barrier free campus.pdf" },
    { title: "Fire Safety", link: "/docs/fire safety certificate.pdf" },
    { title: "Food Safety", link: "/docs/food safety.pdf" },
    { title: "Occupancy", link: "/docs/Occupancy Certificate.pdf" },
    { title: "Structural Stability", link: "/docs/structural stability.pdf" },
    { title: "Student Counselor", link: "/docs/student counselor 2025.pdf" },
    { title: "Anti-Ragging Committee", link: "/docs/antiragging cell.pdf" },
  ];

  return (
    <>
      <Helmet>
        <title>Mandatory Disclosures - VBU MCA</title>
      </Helmet>
      <div className="PageContainer">
        <div id="Heading">
          <h1>Mandatory Disclosures</h1>
        </div>
        <div className="EoaContainer" data-aos="fade-up">
          <p className="EoaDesc">
            In compliance with AICTE guidelines and statutory requirements for technical institutions, the University Department of Computer Applications maintains the following certificates and documentation.
          </p>
          
          <div className="EoaGrid">
            {disclosureDocuments.map((doc, index) => (
              <div key={index} className="EoaCard" data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="EoaCardIcon">
                  <HiOutlineDocumentDownload size={40} />
                </div>
                <div className="EoaCardContent">
                  <h3>{doc.title}</h3>
                  <a href={doc.link} target="_blank" rel="noreferrer" className="DownloadBtn">
                    View Document
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default MandatoryDisclosures;
